import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '@/components/Header';
import { FlowNavigation } from '@/components/FlowNavigation';
import './ServiceReservationGuide.scss';

interface ServiceReservationGuideProps {
    icon: ReactNode;
    title: string;
    description: ReactNode;
    detailLabel: string;
    detailValue: string;
    iconBackgroundColor?: string;
}

export function ServiceReservationGuide({
    icon,
    title,
    description,
    detailLabel,
    detailValue,
    iconBackgroundColor,
}: ServiceReservationGuideProps) {
    const navigate = useNavigate();

    return (
        <div className="service-reservation-guide-page">
            <Header />

            <main className="service-reservation-guide-main">
                <div className="service-reservation-guide-card">
                    <div
                        className="service-reservation-guide-card__icon"
                        style={iconBackgroundColor ? { backgroundColor: iconBackgroundColor } : undefined}
                    >
                        {icon}
                    </div>
                    <h1>{title}</h1>
                    <p>{description}</p>
                    <div className="service-reservation-guide-card__detail">
                        <strong>{detailLabel}</strong>
                        <span>{detailValue}</span>
                    </div>
                </div>
            </main>

            <FlowNavigation
                onPrev={() => navigate('/selection')}
                onNext={() => {}}
                hideNextButton
            />
        </div>
    );
}
